// Port of api/fuel/app/classes/filter/search/games/filters/query/game/version/size/footprint.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'version.size.footprint',
	priority: 65,
	require: function(config, filter) { return filter.version && filter.version.size && rangeActive(filter.version.size.footprint, 0, 99999999) },
	run: function(config, filter, data, query) {
		var expr = '(v.game_version_storage_width * v.game_version_storage_length * v.game_version_storage_depth)'
		if (filter.version.size.footprint.from > 0) query.where(expr, '>=', filter.version.size.footprint.from)
		if (filter.version.size.footprint.to < 99999999) query.where(expr, '<=', filter.version.size.footprint.to)
	}
}
